<template>
  <h6 v-if="!completed" class="text-center" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="200">{{ hint }}</h6>
</template>
<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
  },
  computed: {
    completed() {
      return this.section.completed
    },
    hint() {
      if (this.section.hasHint) {
        return this.$t('sections.' + this.section.title_key + '_hint')
      }
    }
  }
}
</script>
